// ===== 1. Imports =====
import React, { useState } from "react";

// ===== 2. Componente LoginPage =====
export default function LoginPage({ onLogin }) {
  // ===== 2.1 Estados =====
  const [project, setProject] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(""); // ✅ nuevo estado para errores

  // ===== 2.2 Envío del Formulario =====
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validaciones simples
    if (!project.trim())
      return setError("Por favor, introduce el ID del proyecto.");
    if (!email.trim()) return setError("El correo electrónico es obligatorio.");
    if (!password.trim()) return setError("La contraseña es obligatoria.");

    setError("");

    try {
      await onLogin({ project, email, password });
    } catch (err) {
      setError(err.message || "Verifica tus credenciales.");
    }
  };

  // ===== 2.3 Render =====
  return (
    <div
      className="auth-shell"
      style={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "var(--bg)",
        color: "var(--fg)",
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "16px",
        }}
      >
        <div
          className="card"
          style={{
            position: "relative",
            width: "100%",
            maxWidth: 360,
            padding: "56px 16px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            alignItems: "center",
            overflow: "visible",
            border: "1px solid var(--ring)",
            borderRadius: 12,
            background: "var(--card-bg, var(--bg))",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 90,
              height: 90,
              borderRadius: "50%",
              background: "var(--card-bg, var(--bg))",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="/media/LOGO_FILMA.png"
              alt="Logo Filma"
              style={{
                width: "135%",
                height: "135%",
                objectFit: "contain",
              }}
            />
          </div>

          <form
            className="stack"
            onSubmit={handleSubmit}
            style={{ width: "100%" }}
          >
            <div className="stack">
              <label htmlFor="project">Proyecto</label>
              <input
                type="text"
                id="project"
                name="project"
                placeholder="ID del proyecto"
                value={project}
                onChange={(e) => setProject(e.target.value)}
              />
            </div>

            <div className="stack">
              <label htmlFor="email">Correo electrónico</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="tu@correo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="stack">
              <label htmlFor="password">Contraseña</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ width: "100%", paddingRight: 44 }}
                />
                <button
                  type="button"
                  aria-label={
                    showPassword ? "Ocultar contraseña" : "Mostrar contraseña"
                  }
                  onClick={() => setShowPassword((v) => !v)}
                  style={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "1px solid var(--ring)",
                    borderRadius: 6,
                    padding: "2px 8px",
                    fontSize: 12,
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? "Ocultar" : "Ver"}
                </button>
              </div>

              <div style={{ marginTop: 4 }}>
                <a
                  href="#"
                  style={{
                    fontSize: 13,
                    color: "var(--accent)",
                    textDecoration: "none",
                  }}
                >
                  ¿Olvidaste tu contraseña?
                </a>
              </div>
            </div>

            {/* Bloque de error interno */}
            {error && (
              <div
                style={{
                  background: "#fee2e2",
                  color: "#991b1b",
                  padding: "8px 12px",
                  borderRadius: 8,
                  fontSize: 13,
                  marginTop: 8,
                }}
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              className="button button--primary"
              style={{ marginTop: 12 }}
            >
              Iniciar sesión
            </button>
          </form>
        </div>
      </div>

      <footer
        style={{
          position: "fixed",
          bottom: 20,
          left: 0,
          width: "100%",
          textAlign: "center",
          padding: "8px 0",
          fontSize: 10,
          color: "var(--muted)",
          background: "var(--bg)",
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            justifyContent: "center",
          }}
        >
          Filma Accounting® by Filma App | V1.18
        </span>
      </footer>
    </div>
  );
}
